import { render, staticRenderFns } from "./SelectionedGoodsList.vue?vue&type=template&id=577cfb7e&scoped=true"
import script from "./SelectionedGoodsList.vue?vue&type=script&lang=js"
export * from "./SelectionedGoodsList.vue?vue&type=script&lang=js"
import style0 from "./SelectionedGoodsList.vue?vue&type=style&index=0&id=577cfb7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577cfb7e",
  null
  
)

export default component.exports